var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5886 6.4108L8.08858 10.2294L2.3358 8.31159C1.93425 8.17746 1.66372 7.80072 1.66603 7.37746C1.66837 6.9542 1.942 6.57976 2.34511 6.45032L17.053 1.71384C17.4026 1.60146 17.7863 1.69369 18.046 1.9534C18.3057 2.2131 18.398 2.59681 18.2856 2.94644L13.5491 17.6543C13.4196 18.0574 13.0452 18.331 12.6219 18.3334C12.1987 18.3357 11.8219 18.0652 11.6878 17.6636L9.76067 11.8829L13.5886 6.4108Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendMessage);
export default __webpack_public_path__ + "static/media/SendMessage.3ffff23ef9f9e14e74ab01bade8519ac.svg";
export { ForwardRef as ReactComponent };